const raw_url = (process.env.REACT_APP_BACKEND_URL || '').trim();
let normalized_url = raw_url.replace(/\/+$/, '');

// Safeguard: If the URL is provided but missing a protocol, detect if it's a domain and prepend https://
if (normalized_url && !normalized_url.includes('://')) {
    if (normalized_url.includes('.') || normalized_url === 'localhost') {
        normalized_url = `https://${normalized_url}`;
    }
}

// Safeguard: Force HTTPS if the frontend is loaded over HTTPS to prevent Mixed Content errors
if (window.location.protocol === 'https:' && normalized_url.startsWith('http://')) {
    normalized_url = normalized_url.replace('http://', 'https://');
}

export const API_BASE_URL = normalized_url;

// In development with no backend URL set, use relative path so the
// craco dev-server proxy forwards /api/* → http://localhost:8000
export const API_URL = normalized_url ? `${normalized_url}/api` : '/api';

// Determine WebSocket URL from API_BASE_URL
const ws_protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
let ws_host = '';

try {
    if (API_BASE_URL.includes('://')) {
        ws_host = API_BASE_URL.split('://')[1];
    } else {
        ws_host = window.location.host;
    }
} catch (e) {
    ws_host = window.location.host;
}

export const SOCKET_URL = `${ws_protocol}//${ws_host}`;
